module.exports = __webpack_public_path__ + "img/RENT.c019be70.jpg";